import { Controller } from "@hotwired/stimulus";

import { prefersReducedMotion } from "~/lib/viewport";
import { clamp01 } from "~/lib/web/ease";
import { registerScrub } from "~/lib/web/scrub";

export default class WebUnderlinesController extends Controller<HTMLElement> {
  static override targets = ["rule"];
  declare readonly ruleTargets: HTMLElement[];

  private unregister: (() => void) | null = null;

  override connect(): void {
    const rules = this.ruleTargets;
    if (!rules.length) return;
    if (prefersReducedMotion()) {
      for (const rule of rules) rule.style.transform = "scaleX(1)";
      return;
    }
    this.unregister = registerScrub(this.element, (rect, viewportHeight) => {
      const progress = clamp01(
        (viewportHeight * 0.75 - rect.top) / (viewportHeight * 0.5),
      );
      rules.forEach((rule, index) => {
        const drawn = clamp01(progress * rules.length - index);
        rule.style.transform = `scaleX(${drawn.toFixed(3)})`;
      });
    });
  }

  override disconnect(): void {
    this.unregister?.();
    this.unregister = null;
  }
}
